import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './router/menu'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import zh from '@/langs/zh';
import en from '@/langs/en';
import zhTw from '@/langs/zhTw';
import localeZH from 'element-ui/lib/locale/lang/zh-CN'; // 简体中文
import localeTW from 'element-ui/lib/locale/lang/zh-TW'; // 繁体中文
import localeEN from 'element-ui/lib/locale/lang/en'; // 英文
import store from './store';
import { Loading } from 'element-ui';

Vue.use(VueRouter);
Vue.use(VueI18n);

Vue.prototype.$showLoading = function (options = {}) {
  return Loading.service({
    lock: true,
    text: options.text || '加载中...',
    spinner: options.spinner || 'el-icon-loading',
    background: options.background || 'rgba(0, 0, 0, 0.7)',
    target: options.target || document.body
  })
};

Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function () {
      let sign = 0
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
})

Vue.prototype.$hideLoading = function (loadingInstance) {
  loadingInstance && loadingInstance.close()
};

const messages = {
  'en': {
    ...localeEN,
    message: en
  },
  'zh-CN': {
    ...localeZH,
    message: zh
  },
  'zh-TW': {
    ...localeTW,
    message: zhTw
  }
};

let langVal = 'zh-CN';

if (window.localStorage.getItem('lang')) {
  langVal = window.localStorage.getItem('lang');
}

const i18n = new VueI18n({
  locale: langVal,
  messages
})

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false

const router = new VueRouter({
  routes
})

router.beforeEach((to, meta, next) => {
  if (to.meta.nologin) {
    next()
  } else if (!window.sessionStorage.getItem('token')) {
    next('/login')
  } else {
    next()
  }
})

new Vue({
  store,
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
